import { render, staticRenderFns } from "./CSkillInfo.vue?vue&type=template&id=081d2f01&scoped=true&"
import script from "./CSkillInfo.vue?vue&type=script&lang=js&"
export * from "./CSkillInfo.vue?vue&type=script&lang=js&"
import style0 from "./CSkillInfo.vue?vue&type=style&index=0&id=081d2f01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d2f01",
  null
  
)

export default component.exports